module.exports = __webpack_public_path__ + "static/media/img (11).43db1647.png";